import React, { useEffect } from 'react'
import Spinner from 'components/ui/Spinner/Spinner'

const LoadingButton = ({
  className,
  isLoading,
  children,
  disabled,
  type,
  onClick,
  noBtnBase,
  disableEnterKey,
}) => {
  const submitKeyListener = (e) => {
    e.preventDefault()

    // Ignore submit on 'Enter' key entry for mobiles
    if (e.key !== 'Enter' || isLoading || disabled || window.cordova || disableEnterKey)
      return

    onClick(e)
  }

  useEffect(() => {
    document.addEventListener('keyup', submitKeyListener)
    return () => document.removeEventListener('keyup', submitKeyListener)
  })

  return (
    <button
      className={`btn_loading ${noBtnBase ? '' : 'btn_base_v1 offset_mod'} ${
        className || ''
      } ${isLoading ? 'is_loading' : ''}`}
      disabled={disabled}
      type={type}
      onClick={(e) => (e.preventDefault(), !isLoading && onClick(e))}
    >
      {isLoading ? <Spinner className="spinner_button" /> : children}
    </button>
  )
}
export default LoadingButton
